export default class AmendmentAndDocumentHistoryViewModel {
    public ammendmentRef: string = '';
    public ammendmentDetails: string = '';
    public id: number | null = null;
}